
import React from 'react';
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { getReportDialogContent } from "./ReportDialog";
import { ReportFormData } from "@/components/ReportForm/formSchema";

interface CompetitiveAdvantageProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
  isSuccess: boolean;
  onFormSubmit: (data: ReportFormData) => void;
  isLoading: boolean;
  pdfPath?: string;
}

export const CompetitiveAdvantage: React.FC<CompetitiveAdvantageProps> = ({
  isDialogOpen,
  setIsDialogOpen,
  isSuccess,
  onFormSubmit,
  isLoading,
  pdfPath
}) => {
  return (
    <>
      <section className="mb-12">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">Competitive Advantage</h2>
        <p className="text-lg text-white/80 mb-4">
          Download our full report to discover how AI is providing measurable business advantages for firms of all sizes:
        </p>
        <ul className="list-disc pl-5 mb-6 text-white/80">
          <li className="mb-2">How large firms are saving thousands of billable hours</li>
          <li className="mb-2">How small and solo practices achieve efficiency gains of 40-90%</li>
          <li className="mb-2">How to improve client service through strategic automation</li>
          <li className="mb-2">Detailed case studies with actionable insights for your practice</li>
        </ul>
      </section>
      
      <div className="mt-12 flex justify-center">
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild>
            <Button 
              size="lg"
              className="flex items-center gap-2"
            >
              <Download size={20} />
              Get the Report
            </Button>
          </DialogTrigger>
          {getReportDialogContent(isSuccess, onFormSubmit, isLoading, pdfPath)}
        </Dialog>
      </div>
    </>
  );
};

export default CompetitiveAdvantage;
